import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameIntroScene } from 'src/games/JobMatchingGame/scenes/GameIntro';

// Note: RouteComponentProps<{}> MUST be removed if sub-component OR MUST return 'withRouter(PhaserDemo)'
interface PhaserJobMatchingGameProps {
    onComplete: () => void;

}

interface PhaserJobMatchingGameState {
}

const templateConfig: GameConfig = {
    title: "Navigation Game",
    version: "0.9.3",
    physics: {
        default: 'arcade',
        arcade: {
            debug: false,
            gravity: { y: 400 }
        }
    },
    backgroundColor: "#000000"
};

class PhaserJobMatchingGame extends React.Component<PhaserJobMatchingGameProps, PhaserJobMatchingGameState> {
    private game: Phaser.Game;
    constructor(props: PhaserJobMatchingGameProps) {
        super(props);
        bindAllOfThis(this, PhaserJobMatchingGame.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={templateConfig}  onComplete={this.props.onComplete} />
        </div>);
    }
}

export default PhaserJobMatchingGame;



// WEBPACK FOOTER //
// ./src/games/JobMatchingGame/Main.tsx